// Google Maps
(function () {
  function googleMapsLoader (key, callback) {
    var params = [].slice.call(arguments, 2);

    if (window.google && window.google.maps) {
      callback.apply(null, params);
    } else {
      var callbackName = 'callback_' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
      window[callbackName] = function () {
        return callback.apply(null, params);
      };
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?callback=' + callbackName + '&key=' + key;
      document.body.appendChild(script);
    }
  }

  let $maps = $('.js-map'),
      $window = $(window);

  // Create maps
  let createMaps = function () {
    $maps.each(function () {
      let $map     = $(this),
          $canvas  = $map.find('.js-map-canvas'),
          $markers = $map.find('.js-map-marker[data-latitude][data-longitude]'),
          map, bounds, infoWindow;

      let latitude  = $canvas.data('latitude'),
          longitude = $canvas.data('longitude');

      // Init map
      map = new google.maps.Map($canvas[0], {
        center: { lat: 0, lng: 0 },
        zoom: 1,
        disableDefaultUI: true,
        disableDoubleClickZoom: false,
        scrollwheel: false,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL
        }
      });

      bounds = new google.maps.LatLngBounds();

      if (latitude && longitude) {
        bounds.extend({ lat: latitude, lng: longitude });
      }

      infoWindow = new google.maps.InfoWindow();

      // Place markers
      $markers.each(function (index) {
        let $marker   = $(this),
            latitude  = $marker.data('latitude'),
            longitude = $marker.data('longitude'),
            title     = $marker.data('title') || $marker.find('.js-map-title').html(),
            color     = $marker.data('color') || '#000000',
            scale     = $marker.data('scale') || 1,
            detail    = $marker.find('.js-map-detail').html();

        // Create marker
        let position = new google.maps.LatLng(latitude, longitude);
        let marker = new google.maps.Marker({
          position: position,
          title: title,
          icon: {
            path: 'M12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m8.485-12.314C15.8-1.23 8.2-1.23 3.515 3.686-.708 8.114-1.183 16.45 2.4 21.46L12 36l9.6-14.54c3.583-5.01 3.108-13.346-1.115-17.774',
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#000000',
            strokeOpacity: 0.5,
            strokeWeight: 0.5,
            anchor: new google.maps.Point(12, 36),
            scale: scale
          },
          animation: google.maps.Animation.DROP,
          clickable: !!detail
        });

        // Add to map
        setTimeout(() => marker.setMap(map), index * 50);

        // Register event
        google.maps.event.addListener(marker, 'click', () => {
          infoWindow.setContent(detail);
          infoWindow.open(map, marker);
        });

        // Extend bounds
        bounds.extend(position);
      });

      // Force setZoom to 14 once after fitBounds
      let centerMap = function () {
        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
          if (map.getZoom() > 14) {
            map.setZoom(14);
          }
        });
        map.fitBounds(bounds);
      };
      centerMap();

      // Trigger map resize on window resize
      google.maps.event.addListener(map, 'resize', () => centerMap());

      $window.on('debouncedresize', (e) => google.maps.event.trigger(map, 'resize'));
    });
  };

  // Create map once only when visible
  if ($maps.length) {
    let checkResize = function (e) {
      let $map = $maps.first();
      if ($map.find('.js-map-canvas').css('display') !== 'none') {
        googleMapsLoader($map.data('key'), createMaps);
        $window.off('debouncedresize', checkResize);
      }
    };
    $window.on('debouncedresize', checkResize);
    checkResize();
  }
})();
